import { render, staticRenderFns } from "./TagEditView.vue?vue&type=template&id=0d4e854d&"
import script from "./TagEditView.vue?vue&type=script&lang=js&"
export * from "./TagEditView.vue?vue&type=script&lang=js&"
import style0 from "./TagEditView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports